export default __webpack_public_path__ + "b26d1ced9facb344ff5018afe083116d.svg";